import { InPlaceEditable } from '../molecules/InPlaceEditable'

import { ChatRoleType } from '@sourcepilot/generated/shared/enums';
import { Step } from '@sourcepilot/generated/chat/api/step';
import { isLocalUuid } from '@sourcepilot/framework/uuid';
import { Spinner } from './spinner';

export function UserMessage({ message }: { message: Step }) {
  // Check if this is a pending message (local UUID = not yet confirmed by server)
  const isPending = !message.id || isLocalUuid(message.id);
  const handleEdit = (id: string, newText: string) => {
    /* setMessages(prevMessages => {
      return prevMessages.map(msg => msg.id === id ? { ...msg, text: newText } : msg)
    }) */
  }

  const handleDelete = (id: string) => {
    // Delete using the chainlit client?
    /* setMessages(messages.filter(msg => msg.id !== id)) */
  }
  return (
    <div className={`flex flex-col flex-grow items-end`}>
      <div className={`p-[5px] bg-gray-100 border border-gray-200 rounded-[5px] mr-[2px] ${isPending ? 'opacity-70' : ''}`}>
        <div className="flex items-center gap-2">
          {message.role === ChatRoleType.USER ? (
            <InPlaceEditable
              onSave={(value) => handleEdit(message.id || '', value as string)}
              onDelete={() => handleDelete(message.id || '')}
              editable={!isPending}
              iconPosition="bottom"
              inputType="textarea"
              className="text-gray-900"
              defaultOpen={false}
              placeholder="Type a message..."
              values={[message.text || '']}
            >
              <div className="text-gray-900 whitespace-pre-wrap">{message.text || ''}</div>
            </InPlaceEditable>
          ) : (
            <div className="text-gray-900 whitespace-pre-wrap">{message.text || ''}</div>
          )}
          {/* Loading spinner for pending messages - inside box, to the right */}
          {isPending && (
            <Spinner size="sm" className="opacity-60 flex-shrink-0" />
          )}
        </div>
      </div>
    </div>
  )
}